/*
import &1 from "./SDWFigures_&_1.png" 
import &2 from "./SDWFigures_&_2.png" 
import &3 from "./SDWFigures_&_3.png" 
import &4 from "./SDWFigures_&_4.png" 
import &5 from "./SDWFigures_&_5.png" 
import &6 from "./SDWFigures_&_6.png" 
import &7 from "./SDWFigures_&_7.png" 
*/
import COMMUTE1 from "./SDWFigures_COMMUTE_1.png?w=150&u=px";
import COMMUTE2 from "./SDWFigures_COMMUTE_2.png?w=150&u=px";
import COMMUTE3 from "./SDWFigures_COMMUTE_3.png?w=150&u=px";
import COMMUTE4 from "./SDWFigures_COMMUTE_4.png?w=150&u=px";
import COMMUTE5 from "./SDWFigures_COMMUTE_5.png?w=150&u=px";
import COMMUTE6 from "./SDWFigures_COMMUTE_6.png?w=150&u=px";
import COMMUTE7 from "./SDWFigures_COMMUTE_7.png?w=150&u=px";

import DESIGN1 from "./SDWFigures_DESIGN_1.png?w=150&u=px";
import DESIGN2 from "./SDWFigures_DESIGN_2.png?w=150&u=px";
import DESIGN3 from "./SDWFigures_DESIGN_3.png?w=150&u=px";
import DESIGN4 from "./SDWFigures_DESIGN_4.png?w=150&u=px";
import DESIGN5 from "./SDWFigures_DESIGN_5.png?w=150&u=px";
import DESIGN6 from "./SDWFigures_DESIGN_6.png?w=150&u=px";
import DESIGN7 from "./SDWFigures_DESIGN_7.png?w=150&u=px";

import DISPLAY1 from "./SDWFigures_DISPLAY_1.png?w=150&u=px";
import DISPLAY2 from "./SDWFigures_DISPLAY_2.png?w=150&u=px";
import DISPLAY3 from "./SDWFigures_DISPLAY_3.png?w=150&u=px";
import DISPLAY4 from "./SDWFigures_DISPLAY_4.png?w=150&u=px";
import DISPLAY5 from "./SDWFigures_DISPLAY_5.png?w=150&u=px";
import DISPLAY6 from "./SDWFigures_DISPLAY_6.png?w=150&u=px";
import DISPLAY7 from "./SDWFigures_DISPLAY_7.png?w=150&u=px";

import EAT1 from "./SDWFigures_EAT_1.png?w=150&u=px";
import EAT2 from "./SDWFigures_EAT_2.png?w=150&u=px";
import EAT3 from "./SDWFigures_EAT_3.png?w=150&u=px";
import EAT4 from "./SDWFigures_EAT_4.png?w=150&u=px";
import EAT5 from "./SDWFigures_EAT_5.png?w=150&u=px";
import EAT6 from "./SDWFigures_EAT_6.png?w=150&u=px";
import EAT7 from "./SDWFigures_EAT_7.png?w=150&u=px";

import HEAL1 from "./SDWFigures_HEAL_1.png?w=150&u=px";
import HEAL2 from "./SDWFigures_HEAL_2.png?w=150&u=px";
import HEAL3 from "./SDWFigures_HEAL_3.png?w=150&u=px";
import HEAL4 from "./SDWFigures_HEAL_4.png?w=150&u=px";
import HEAL5 from "./SDWFigures_HEAL_5.png?w=150&u=px";
import HEAL6 from "./SDWFigures_HEAL_6.png?w=150&u=px";
import HEAL7 from "./SDWFigures_HEAL_7.png?w=150&u=px";

import MAKE1 from "./SDWFigures_MAKE_1.png?w=150&u=px";
import MAKE2 from "./SDWFigures_MAKE_2.png?w=150&u=px";
import MAKE3 from "./SDWFigures_MAKE_3.png?w=150&u=px";
import MAKE4 from "./SDWFigures_MAKE_4.png?w=150&u=px";
import MAKE5 from "./SDWFigures_MAKE_5.png?w=150&u=px";
import MAKE6 from "./SDWFigures_MAKE_6.png?w=150&u=px";
import MAKE7 from "./SDWFigures_MAKE_7.png?w=150&u=px";

import PLANT1 from "./SDWFigures_PLANT_1.png?w=150&u=px";
import PLANT2 from "./SDWFigures_PLANT_2.png?w=150&u=px";
import PLANT3 from "./SDWFigures_PLANT_3.png?w=150&u=px";
import PLANT4 from "./SDWFigures_PLANT_4.png?w=150&u=px";
import PLANT5 from "./SDWFigures_PLANT_5.png?w=150&u=px";
import PLANT6 from "./SDWFigures_PLANT_6.png?w=150&u=px";
import PLANT7 from "./SDWFigures_PLANT_7.png?w=150&u=px";

import READ1 from "./SDWFigures_READ_1.png?w=150&u=px";
import READ2 from "./SDWFigures_READ_2.png?w=150&u=px";
import READ3 from "./SDWFigures_READ_3.png?w=150&u=px";
import READ4 from "./SDWFigures_READ_4.png?w=150&u=px";
import READ5 from "./SDWFigures_READ_5.png?w=150&u=px";
import READ6 from "./SDWFigures_READ_6.png?w=150&u=px";
import READ7 from "./SDWFigures_READ_7.png?w=150&u=px";

import SHOP1 from "./SDWFigures_SHOP_1.png?w=150&u=px";
import SHOP2 from "./SDWFigures_SHOP_2.png?w=150&u=px";
import SHOP3 from "./SDWFigures_SHOP_3.png?w=150&u=px";
import SHOP4 from "./SDWFigures_SHOP_4.png?w=150&u=px";
import SHOP5 from "./SDWFigures_SHOP_5.png?w=150&u=px";
import SHOP6 from "./SDWFigures_SHOP_6.png?w=150&u=px";
import SHOP7 from "./SDWFigures_SHOP_7.png?w=150&u=px";

import SLEEP1 from "./SDWFigures_SLEEP_1.png?w=150&u=px";
import SLEEP2 from "./SDWFigures_SLEEP_2.png?w=150&u=px";
import SLEEP3 from "./SDWFigures_SLEEP_3.png?w=150&u=px";
import SLEEP4 from "./SDWFigures_SLEEP_4.png?w=150&u=px";
import SLEEP5 from "./SDWFigures_SLEEP_5.png?w=150&u=px";
import SLEEP6 from "./SDWFigures_SLEEP_6.png?w=150&u=px";
import SLEEP7 from "./SDWFigures_SLEEP_7.png?w=150&u=px";

// webp
import webpCOMMUTE1 from "./SDWFigures_COMMUTE_1.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE2 from "./SDWFigures_COMMUTE_2.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE3 from "./SDWFigures_COMMUTE_3.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE4 from "./SDWFigures_COMMUTE_4.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE5 from "./SDWFigures_COMMUTE_5.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE6 from "./SDWFigures_COMMUTE_6.png?as=w&w=150&u=px&h=auto";
import webpCOMMUTE7 from "./SDWFigures_COMMUTE_7.png?as=w&w=150&u=px&h=auto";

import webpDESIGN1 from "./SDWFigures_DESIGN_1.png?as=w&w=150&u=px&h=auto";
import webpDESIGN2 from "./SDWFigures_DESIGN_2.png?as=w&w=150&u=px&h=auto";
import webpDESIGN3 from "./SDWFigures_DESIGN_3.png?as=w&w=150&u=px&h=auto";
import webpDESIGN4 from "./SDWFigures_DESIGN_4.png?as=w&w=150&u=px&h=auto";
import webpDESIGN5 from "./SDWFigures_DESIGN_5.png?as=w&w=150&u=px&h=auto";
import webpDESIGN6 from "./SDWFigures_DESIGN_6.png?as=w&w=150&u=px&h=auto";
import webpDESIGN7 from "./SDWFigures_DESIGN_7.png?as=w&w=150&u=px&h=auto";

import webpDISPLAY1 from "./SDWFigures_DISPLAY_1.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY2 from "./SDWFigures_DISPLAY_2.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY3 from "./SDWFigures_DISPLAY_3.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY4 from "./SDWFigures_DISPLAY_4.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY5 from "./SDWFigures_DISPLAY_5.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY6 from "./SDWFigures_DISPLAY_6.png?as=w&w=150&u=px&h=auto";
import webpDISPLAY7 from "./SDWFigures_DISPLAY_7.png?as=w&w=150&u=px&h=auto";

import webpEAT1 from "./SDWFigures_EAT_1.png?as=w&w=150&u=px&h=auto";
import webpEAT2 from "./SDWFigures_EAT_2.png?as=w&w=150&u=px&h=auto";
import webpEAT3 from "./SDWFigures_EAT_3.png?as=w&w=150&u=px&h=auto";
import webpEAT4 from "./SDWFigures_EAT_4.png?as=w&w=150&u=px&h=auto";
import webpEAT5 from "./SDWFigures_EAT_5.png?as=w&w=150&u=px&h=auto";
import webpEAT6 from "./SDWFigures_EAT_6.png?as=w&w=150&u=px&h=auto";
import webpEAT7 from "./SDWFigures_EAT_7.png?as=w&w=150&u=px&h=auto";

import webpHEAL1 from "./SDWFigures_HEAL_1.png?as=w&w=150&u=px&h=auto";
import webpHEAL2 from "./SDWFigures_HEAL_2.png?as=w&w=150&u=px&h=auto";
import webpHEAL3 from "./SDWFigures_HEAL_3.png?as=w&w=150&u=px&h=auto";
import webpHEAL4 from "./SDWFigures_HEAL_4.png?as=w&w=150&u=px&h=auto";
import webpHEAL5 from "./SDWFigures_HEAL_5.png?as=w&w=150&u=px&h=auto";
import webpHEAL6 from "./SDWFigures_HEAL_6.png?as=w&w=150&u=px&h=auto";
import webpHEAL7 from "./SDWFigures_HEAL_7.png?as=w&w=150&u=px&h=auto";

import webpMAKE1 from "./SDWFigures_MAKE_1.png?as=w&w=150&u=px&h=auto";
import webpMAKE2 from "./SDWFigures_MAKE_2.png?as=w&w=150&u=px&h=auto";
import webpMAKE3 from "./SDWFigures_MAKE_3.png?as=w&w=150&u=px&h=auto";
import webpMAKE4 from "./SDWFigures_MAKE_4.png?as=w&w=150&u=px&h=auto";
import webpMAKE5 from "./SDWFigures_MAKE_5.png?as=w&w=150&u=px&h=auto";
import webpMAKE6 from "./SDWFigures_MAKE_6.png?as=w&w=150&u=px&h=auto";
import webpMAKE7 from "./SDWFigures_MAKE_7.png?as=w&w=150&u=px&h=auto";

import webpPLANT1 from "./SDWFigures_PLANT_1.png?as=w&w=150&u=px&h=auto";
import webpPLANT2 from "./SDWFigures_PLANT_2.png?as=w&w=150&u=px&h=auto";
import webpPLANT3 from "./SDWFigures_PLANT_3.png?as=w&w=150&u=px&h=auto";
import webpPLANT4 from "./SDWFigures_PLANT_4.png?as=w&w=150&u=px&h=auto";
import webpPLANT5 from "./SDWFigures_PLANT_5.png?as=w&w=150&u=px&h=auto";
import webpPLANT6 from "./SDWFigures_PLANT_6.png?as=w&w=150&u=px&h=auto";
import webpPLANT7 from "./SDWFigures_PLANT_7.png?as=w&w=150&u=px&h=auto";

import webpREAD1 from "./SDWFigures_READ_1.png?as=w&w=150&u=px&h=auto";
import webpREAD2 from "./SDWFigures_READ_2.png?as=w&w=150&u=px&h=auto";
import webpREAD3 from "./SDWFigures_READ_3.png?as=w&w=150&u=px&h=auto";
import webpREAD4 from "./SDWFigures_READ_4.png?as=w&w=150&u=px&h=auto";
import webpREAD5 from "./SDWFigures_READ_5.png?as=w&w=150&u=px&h=auto";
import webpREAD6 from "./SDWFigures_READ_6.png?as=w&w=150&u=px&h=auto";
import webpREAD7 from "./SDWFigures_READ_7.png?as=w&w=150&u=px&h=auto";

import webpSHOP1 from "./SDWFigures_SHOP_1.png?as=w&w=150&u=px&h=auto";
import webpSHOP2 from "./SDWFigures_SHOP_2.png?as=w&w=150&u=px&h=auto";
import webpSHOP3 from "./SDWFigures_SHOP_3.png?as=w&w=150&u=px&h=auto";
import webpSHOP4 from "./SDWFigures_SHOP_4.png?as=w&w=150&u=px&h=auto";
import webpSHOP5 from "./SDWFigures_SHOP_5.png?as=w&w=150&u=px&h=auto";
import webpSHOP6 from "./SDWFigures_SHOP_6.png?as=w&w=150&u=px&h=auto";
import webpSHOP7 from "./SDWFigures_SHOP_7.png?as=w&w=150&u=px&h=auto";

import webpSLEEP1 from "./SDWFigures_SLEEP_1.png?as=w&w=150&u=px&h=auto";
import webpSLEEP2 from "./SDWFigures_SLEEP_2.png?as=w&w=150&u=px&h=auto";
import webpSLEEP3 from "./SDWFigures_SLEEP_3.png?as=w&w=150&u=px&h=auto";
import webpSLEEP4 from "./SDWFigures_SLEEP_4.png?as=w&w=150&u=px&h=auto";
import webpSLEEP5 from "./SDWFigures_SLEEP_5.png?as=w&w=150&u=px&h=auto";
import webpSLEEP6 from "./SDWFigures_SLEEP_6.png?as=w&w=150&u=px&h=auto";
import webpSLEEP7 from "./SDWFigures_SLEEP_7.png?as=w&w=150&u=px&h=auto";
const allShowCaseNameImg = {
  COMMUTE1,
  COMMUTE2,
  COMMUTE3,
  COMMUTE4,
  COMMUTE5,
  COMMUTE6,
  COMMUTE7,
  DESIGN1,
  DESIGN2,
  DESIGN3,
  DESIGN4,
  DESIGN5,
  DESIGN6,
  DESIGN7,
  DISPLAY1,
  DISPLAY2,
  DISPLAY3,
  DISPLAY4,
  DISPLAY5,
  DISPLAY6,
  DISPLAY7,
  EAT1,
  EAT2,
  EAT3,
  EAT4,
  EAT5,
  EAT6,
  EAT7,
  HEAL1,
  HEAL2,
  HEAL3,
  HEAL4,
  HEAL5,
  HEAL6,
  HEAL7,
  MAKE1,
  MAKE2,
  MAKE3,
  MAKE4,
  MAKE5,
  MAKE6,
  MAKE7,
  PLANT1,
  PLANT2,
  PLANT3,
  PLANT4,
  PLANT5,
  PLANT6,
  PLANT7,
  READ1,
  READ2,
  READ3,
  READ4,
  READ5,
  READ6,
  READ7,
  SHOP1,
  SHOP2,
  SHOP3,
  SHOP4,
  SHOP5,
  SHOP6,
  SHOP7,
  SLEEP1,
  SLEEP2,
  SLEEP3,
  SLEEP4,
  SLEEP5,
  SLEEP6,
  SLEEP7,
  //
  webpCOMMUTE1,
  webpCOMMUTE2,
  webpCOMMUTE3,
  webpCOMMUTE4,
  webpCOMMUTE5,
  webpCOMMUTE6,
  webpCOMMUTE7,
  webpDESIGN1,
  webpDESIGN2,
  webpDESIGN3,
  webpDESIGN4,
  webpDESIGN5,
  webpDESIGN6,
  webpDESIGN7,
  webpDISPLAY1,
  webpDISPLAY2,
  webpDISPLAY3,
  webpDISPLAY4,
  webpDISPLAY5,
  webpDISPLAY6,
  webpDISPLAY7,
  webpEAT1,
  webpEAT2,
  webpEAT3,
  webpEAT4,
  webpEAT5,
  webpEAT6,
  webpEAT7,
  webpHEAL1,
  webpHEAL2,
  webpHEAL3,
  webpHEAL4,
  webpHEAL5,
  webpHEAL6,
  webpHEAL7,
  webpMAKE1,
  webpMAKE2,
  webpMAKE3,
  webpMAKE4,
  webpMAKE5,
  webpMAKE6,
  webpMAKE7,
  webpPLANT1,
  webpPLANT2,
  webpPLANT3,
  webpPLANT4,
  webpPLANT5,
  webpPLANT6,
  webpPLANT7,
  webpREAD1,
  webpREAD2,
  webpREAD3,
  webpREAD4,
  webpREAD5,
  webpREAD6,
  webpREAD7,
  webpSHOP1,
  webpSHOP2,
  webpSHOP3,
  webpSHOP4,
  webpSHOP5,
  webpSHOP6,
  webpSHOP7,
  webpSLEEP1,
  webpSLEEP2,
  webpSLEEP3,
  webpSLEEP4,
  webpSLEEP5,
  webpSLEEP6,
  webpSLEEP7,
};

export default allShowCaseNameImg;
